/*=====================================================================*\
   @new
   - Keen Slider powered carousel for video elements
\*=====================================================================*/

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class VideoCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        mode: 'snap',
        slides: {
          perView: 1
        }
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('tba-video-carousel')) {
  customElements.define('tba-video-carousel', VideoCarousel)
}
